import { createAsyncThunk } from '@reduxjs/toolkit';
import { showAppLoader, hideAppLoader } from '../../Shared/Loader/LoaderSlice';
import ProviderManager from '../../../provider/providerManager';
import { goToPage, setErrorPage } from './WifiManagementBlockSlice';
import { forEach } from 'lodash';


export const prepareSaleAsync = createAsyncThunk('wifiManagementBlock/prepareSaleAsync', async (data, thunkAPI) => {

    let state = thunkAPI.getState().wifiManagementBlock;

    const routerNotAllowed = state.routerNotAllowed || [];
    const hasBlockedRouter = state.subscriber.equipments?.find(x => routerNotAllowed.includes(x.productId));
    if (hasBlockedRouter) {
        thunkAPI.dispatch(setErrorPage('ROUTER_NOT_ALLOWED_IN_EPI_ERROR'));
        return;
    }

    const foreignEquipments = state.subscriber.equipments?.find(x=> x.productId == 'NATAVT' || x.productId == '39081NB');
    if (foreignEquipments) {
        thunkAPI.dispatch(setErrorPage('FOREIGN_EQUIPMENTS_ERROR'));
        return;
    }

    const res = await thunkAPI.dispatch(getWifiDataAsync({ isDisplayLoader: true })); //1505
    const isSuccess = res?.payload?.errorCode == '0';

    if(!isSuccess) {
        thunkAPI.dispatch(setErrorPage('GET_WIFI_DATA_ERROR'));
        return;
    }

    //thunkAPI.dispatch(setErrorPage('NO_SUBSCRIBER_ERROR')); return;
    //thunkAPI.dispatch(goToPage('chooseNetworkPage')); return;//TODO delete this
    //thunkAPI.dispatch(goToPage('guestNetworkPage')); return;//TODO delete this
    //thunkAPI.dispatch(goToPage('homeNetworkPage')); return; //TODO delete this
    //thunkAPI.dispatch(goToPage('networkTypePage')); return;//TODO delete this
    //thunkAPI.dispatch(goToPage('addNetworkPage')); return; //TODO delete this

    switch (state.wifiFlowType) {
        case 'HOME_NETWORK':
            thunkAPI.dispatch(goToPage('homeNetworkPage'));
            break;
        case 'GUEST_NETWORK':
            thunkAPI.dispatch(goToPage('guestNetworkPage'));
            break;
        default:
            thunkAPI.dispatch(goToPage('chooseNetworkPage'));
            break;
    }

});


export const getWifiDataAsync = createAsyncThunk('wifiManagementBlock/getWifiDataAsync', async (data, thunkAPI) => {

    if (data?.isDisplayLoader) {
        thunkAPI.dispatch(showAppLoader());
    }

    try {
        const state = thunkAPI.getState().wifiManagementBlock;

        const params = {
            ban: state.subscriber.ban
        };
        const result = await ProviderManager.getProviderData('getWifiData', params);
        //const isSuccess = (result?.Body?.errorCode == '0');
        return result?.Body;

    } catch (error) {

    } finally {
        if (data?.isDisplayLoader) {
            thunkAPI.dispatch(hideAppLoader());
        }
    }

});


export const updateWifiSettingsAsync = createAsyncThunk('wifiManagementBlock/updateWifiSettingsAsync', async (data, thunkAPI) => {

    if (data?.isDisplayLoader) {
        thunkAPI.dispatch(showAppLoader());
    }

    try {
        const state = thunkAPI.getState().wifiManagementBlock;

        let networkWiFis = [...state.networkWiFis];
        console.info('data.networkList', data.networkList);

        data.networkList.forEach((itemToUpdate) => {
            const item = networkWiFis.find(x=> x.networkType == itemToUpdate.networkType);
            if(item) {
                let index = networkWiFis.findIndex(x=> x.networkType == itemToUpdate.networkType);
                networkWiFis[index] = itemToUpdate;
            }
            else {
                networkWiFis.push(itemToUpdate);
            }
        });


        const params = {
            ban: state.subscriber.ban,
            networkWiFis: networkWiFis
        };

        console.info('params', params);

        const result = await ProviderManager.getProviderData('updateWifiSettings', params);
        const isSuccess = result?.Body?.checkConnection?.isSuccess;

        if (isSuccess) {
            await thunkAPI.dispatch(getWifiDataAsync({ isDisplayLoader: false }));
        }

        return result?.Body;

    } catch (error) {

    } finally {
        if (data?.isDisplayLoader) {
            thunkAPI.dispatch(hideAppLoader());
        }
    }

});

